import React from "react";
import Navbar from "../../components/navigation/web/Navbar";
import SundayToolE from "./SundayToolE";
const SundayTool = () => {
	return (
		<>
			<Navbar
				view={{
					title: "Herramienta de Domingos",
					component: (
						<>
							<SundayToolE />
						</>
					),
				}}
				right={{
					title: "Right",
					component: null,
				}}
			/>
		</>
	);
};

export { SundayTool };
